export default class FiltroModelliScadenzario{

    SitoIntervento;
    RepartoIntervento;
    UnitaIntervento;
    EntitaIntervento;
    DataFinoA;

    constructor(sitoIntervento, repartoIntervento, unitaIntervento, entitaIntervento, dataFinoA){
        this.SitoIntervento = sitoIntervento;
        this.RepartoIntervento = repartoIntervento;
        this.UnitaIntervento = unitaIntervento;
        this.EntitaIntervento = entitaIntervento;
        this.DataFinoA = dataFinoA;
    }
}